import { getApiUrl, tokenInterceptor } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/users'),
    prepareHeaders: tokenInterceptor,
  }),
  endpoints: (builder) => ({
    create: builder.mutation({
      query: (user) => ({
        url: ``,
        method: 'POST',
        body: {
          ...user,
        },
      }),
    }),
    update: builder.mutation({
      query: (user) => ({
        url: `${user.id}`,
        method: 'PUT',
        body: {
          ...user,
        },
      }),
    }),
    delete: builder.mutation({
      query: (uuid) => ({
        url: `/${uuid}`,
        method: 'DELETE',
      }),
    }),
    getAllUsers: builder.query({
      query: () => ({
        url: ``,
        method: 'GET',
      }),
    }),
    getUser: builder.mutation({
      query: (uuid) => ({
        url: `/${uuid}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useCreateMutation,
  useUpdateMutation,
  useGetAllUsersQuery,
  useGetUserMutation,
  useDeleteMutation,
} = userApi;
